import React, { useEffect, useState } from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import { homeService, IKeyWordsPieType } from './homeService';


export const KeyWords = () => {
	const [dataSource, setDataSource] = useState<IKeyWordsPieType[]>([]);

	const getValue = async () => {
		let { retData } = await homeService.keyWordStatistics();
		retData && setDataSource(retData);
	}

	useEffect(() => {
		getValue();
	}, []);

	const option = {
		grid: {
			left: 60,
			right: 20,
			top: 30,
		},
		tooltip: {
			trigger: "item"
		},
		series: [
			{
				// tooltip: {

				// },
				name: "关键词分布",
				type: 'pie',
				radius: ['36%', '55%'],
				label: {
					show: false,
					position: 'center'
				},
				emphasis: {
					label: {
						show: true,
						fontSize: '20',
						color: "#FFF"
					}
				},
				labelLine: {
					show: false
				},
				//动画
				animation: true,
				animationType: 'expansion',
				animationEasing: 'cubicOut',
				//数据
				data: dataSource,
				color: [ //自定义的颜色
					'#0228CB',
					'#5E2AE8',
					'#33DDF8',
					'#8608DE',
					'#173E8D',
					'#3C29B8'
				]
			},

			//外环
			{
				type: 'pie',
				radius: ["55%", '65%'],

				//外环颜色和阴影
				itemStyle: {
					color: "#0D1441",
					shadowColor: '#0D2562',
					shadowBlur: 15
				},
				//标签
				label: {
					color: "#FFF",
					formatter: '{name|{b}}\n{time|{c} 条}',
					lineHeight: 15,
					//标签颜色
					rich: {
						time: {
							fontSize: 14,
							color: '#fff',
						},
						name: {
							fontSize: 14,
							color: '#fff',
						}
					}
				},
				//高亮状态的扇区和标签样式
				emphasis: {
					//禁止高亮
					scale: false,
					//线长度
				},
				labelLine: {
					normal: {
						lineStyle: {
							color: '#FFF'
						},
						smooth: 0.2,
						length: 20,
						length2: 5,
					},
					length: 20
				},


				//数据
				data: dataSource
			},
		]
	}
	return (
		<div className="home-keyWords">
			<div className="home-but-wrapper">
				<span>关键词分布</span>
			</div>
			<div className="home-keyWords-wrapper">
				<ReactEchartsCore
					echarts={echarts}
					theme="pie"
					option={option as any}
					style={{ height: "100%" }}
				/>
			</div>
		</div>
	)
}